import { RefObject, useEffect } from 'react';
import { useErrorFieldContext } from '../error-field-context';

const useRegisterErrorField = (fieldRef: RefObject<HTMLDivElement> | RefObject<HTMLLabelElement>, errorType: string | undefined) => {
  const { registerErrorField, unregisterErrorField } = useErrorFieldContext();

  useEffect(() => {
    const currentRef = fieldRef.current;
    if (errorType && currentRef) {
      registerErrorField(currentRef);
    }

    return () => {
      if (currentRef) {
        unregisterErrorField(currentRef);
      }
    };
  }, [fieldRef, errorType, registerErrorField, unregisterErrorField]);
};

export default useRegisterErrorField;
